var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-pageframe',{attrs:{"title":"View Payment"}},[_c('v-container',[(_vm.payment != null)?_c('m-payment-card',{attrs:{"payment":_vm.payment},on:{"changed":_vm.loadPayment}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }